var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgPillIdIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.24976 17.1523L4.7895 15.3181L13.8743 20.977L12.4652 22.6107L7.04772 21.1475L3.24976 17.1523Z",
    fill: "#EFF7FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.44663 22.5131L1.3208 24.7912L2.51955 27.0067L4.91802 27.5603L8.19921 26.8221L10.1558 23.4976L3.15063 19.6204L1.44663 22.5131Z",
    fill: "#EFF7FE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9542 14.7463L13.8738 20.9767L4.78906 15.3177L8.86943 9.08739C10.4697 6.64527 13.8085 5.92678 16.3136 7.48741C18.8177 9.04804 19.5545 12.3042 17.9542 14.7463Z",
    fill: "#0093C6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1915 9.16874C14.4346 8.69755 13.5336 8.54205 12.6538 8.73221C11.7749 8.9205 11.0247 9.43103 10.5406 10.1692C10.3715 10.4277 10.019 10.5036 9.75389 10.3378C9.48782 10.1729 9.41002 9.82915 9.58003 9.57061C10.2274 8.58233 11.2322 7.8985 12.4088 7.64558C13.5855 7.39172 14.7919 7.60061 15.8043 8.23198C16.0704 8.39685 16.1482 8.74064 15.9791 9.00012C15.8937 9.12939 15.763 9.21277 15.6209 9.24368C15.4787 9.27459 15.3231 9.25211 15.1915 9.16874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Exclude",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9336 20.3874L5.2811 14.9992L9.16744 9.06583C10.6908 6.73987 13.8712 6.05604 16.2562 7.54173C18.6412 9.02742 19.3424 12.129 17.819 14.455L13.9336 20.3874ZM13.7509 22.7125L18.7793 15.0536C20.6418 12.2105 19.785 8.42041 16.8698 6.60405C13.9545 4.78862 10.0672 5.6242 8.2057 8.46725L3.34058 15.8994L3.92362 17.076L4.66708 15.9369L13.3186 21.3251L12.4647 22.6113L13.7509 22.7125Z",
    fill: "#06162D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0135 23.113L8.36711 25.6281C7.87243 26.3813 7.10784 26.9031 6.21166 27.0951C5.31548 27.2881 4.39624 27.1298 3.62301 26.6473C2.02756 25.6534 1.55785 23.5785 2.57698 22.0216L4.23295 19.4924L3.29259 18.0957L1.26009 21.201C0.542565 22.2961 0.305313 23.601 0.592513 24.874C0.880675 26.1462 1.65775 27.2328 2.78158 27.9325C3.59323 28.4384 4.51631 28.6988 5.45956 28.6988C5.82072 28.6988 6.18573 28.6604 6.54785 28.5827C7.85322 28.3016 8.96744 27.5438 9.684 26.4487L11.7415 23.3078L10.0135 23.113Z",
    fill: "#06162D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Exclude_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.86592 5.72964C4.01784 7.53289 2.99967 9.9291 2.99967 12.4789C2.99967 15.0278 4.01784 17.425 5.86592 19.2273C7.71495 21.0296 10.172 22.0235 12.7866 22.0235C15.4002 22.0235 17.8582 21.0296 19.7063 19.2273C23.5225 15.5065 23.5225 9.45136 19.7063 5.72964C17.7987 3.86925 15.2926 2.93905 12.7866 2.93905C10.2806 2.93905 7.77451 3.86925 5.86592 5.72964ZM4.01728 21.0306C1.67452 18.7468 0.384521 15.7089 0.384521 12.4789C0.384521 9.24808 1.67452 6.21113 4.01728 3.92732C6.35907 1.64258 9.47313 0.384521 12.786 0.384521C16.098 0.384521 19.212 1.64258 21.5548 3.92732C23.8966 6.21113 25.1866 9.24808 25.1866 12.4789C25.1866 15.7089 23.8966 18.7468 21.5548 21.0306C19.212 23.3144 16.098 24.5734 12.786 24.5734C9.47313 24.5734 6.35907 23.3144 4.01728 21.0306Z",
    fill: "#06162D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.036 19.5266L29.3976 26.7059C29.9835 27.2773 29.825 28.3658 29.047 29.1255C28.268 29.8852 27.1518 30.0389 26.5659 29.4665L19.2043 22.2882L22.036 19.5266Z",
    fill: "#06162D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.1712 15.4392L9.70134 13.1113C9.87136 12.8537 10.1028 12.7938 10.3487 12.9474C10.5946 13.102 10.6379 13.3352 10.4698 13.591L8.93963 15.9188C8.77058 16.1773 8.53813 16.2363 8.29415 16.0837C8.04825 15.93 8.00311 15.6949 8.1712 15.4392Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.44085 16.0599C9.59262 16.1545 9.6368 16.3521 9.53979 16.5001C9.44278 16.6481 9.2401 16.6912 9.08738 16.5966C8.93753 16.5029 8.89239 16.3044 8.9894 16.1563C9.08642 16.0083 9.29101 15.9652 9.44085 16.0599Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Exclude_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1612 17.0044C11.6886 17.3342 12.1208 17.189 12.5521 16.5332C12.9815 15.8794 12.9373 15.4335 12.4099 15.1038L12.0536 14.8808L10.8049 16.7815L11.1612 17.0044ZM11.3935 14.2354C11.577 13.9581 11.8325 13.9066 12.1225 14.0883L12.9188 14.5848C13.8506 15.1684 13.9956 16.019 13.3357 17.0232C12.6739 18.0293 11.8209 18.2559 10.8892 17.6733L10.0939 17.1768C9.80285 16.9951 9.74329 16.7478 9.9258 16.4686L11.3935 14.2354Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7404 18.0832C12.8922 18.1787 12.9364 18.3764 12.8394 18.5244C12.7423 18.6715 12.5397 18.7155 12.3869 18.6199C12.2371 18.5263 12.1919 18.3277 12.289 18.1806C12.386 18.0326 12.5906 17.9886 12.7404 18.0832Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPillIdIcon);
export default __webpack_public_path__ + "static/media/pill_id_icon.9522014aefeae8e1ece95d07f3ce8fc5.svg";
export { ForwardRef as ReactComponent };